<template>
  <div id="app">
      <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'app'
}
</script>

<style>
*,div,body,h1,h2,h3,h4{
  margin:0;
  padding:0;
}
#app {
  font-family: '微软雅黑','Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  /*color: #2c3e50;*/
  color: #626262;
  background:  #E6E6E6;
}
</style>



// WEBPACK FOOTER //
// App.vue?82c1b9f6